export default "__VITE_ASSET__DQaAAgrU__"